module.exports = __webpack_public_path__ + "img/producto.0a36558e.png";